/**
 * Detects mentions followed by additional text (e.g., "@user text")
 * Used to hide the search inline suggestions when there's content after a mention
 *
 * @example
 * "@john.doe resume" ✅ | "@john.doe" ❌
 */
export const MENTION_WITH_TEXT_REGEX = /(?:^|\s)@\w+(\.\w+)*\s+\w+/;

/**
 * Regex patterns for parsing skill-related error messages
 */
export const SKILL_PATTERN = {
  SKILL_WITH_ITEMS: /^-\s*(.+?):\s*(.+)$/,
  SKILL_NAME_ONLY: /^-\s*(.+)$/,
} as const;

/**
 * Regex patterns for extracting school names from error messages
 */
export const EDUCATION_PATTERN = {
  // Extract school from format: school: "Name"
  SCHOOL_FIELD: /school:\s*"([^"]+)"/gi,
  // Fallback: extract school from "at [School]" format (end of string)
  SCHOOL_AFTER_AT: /\bat\s+(.+)$/i,
  // Check if error mentions degree-related keywords
  DEGREE_KEYWORDS: /degree|master|bachelor|phd|diploma/,
} as const;

/**
 * Regex patterns for message formatting
 */
export const MESSAGE_PATTERN = {
  // Matches "We " at start, after ", " or " and " to lowercase for "However, " context
  LOWERCASE_WE: /(?:^|(?<=, )|(?<= and ))We /g,
} as const;

export const LINE_BREAK_REGEX = {
  TRAILING: /[\r\n]+$/,
} as const;

/** Alternation of block-level HTML tag names for regex matching */
const BLOCK_TAGS =
  'p|div|li|ul|ol|h[1-6]|blockquote|section|article|header|footer|tr|td|th';

export const BLOCK_TAG_PATTERN = {
  /** Matches `<br>` / `<br/>` / `<br />` (case-insensitive) */
  BR: /<br\s*\/?>/gi,
  /** Matches closing block-level tags like `</p>`, `</div>`, etc. */
  CLOSING: new RegExp(`</(${BLOCK_TAGS})>`, 'gi'),
} as const;
